import React from "react";
import { FiCheckCircle, FiAlertCircle, FiInfo } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

export default function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FFFBF7] font-sans text-slate-900">
      {/* Mini Nav */}
      <nav className="p-6 bg-white border-b border-orange-100 flex justify-between items-center">
        <button 
          onClick={() => navigate("/")}
          className="text-orange-500 font-bold flex items-center gap-2"
        >
          ← Back to Home
        </button>
        <span className="font-black text-slate-800">DIVYA INSTITUTE</span>
      </nav>

      <div className="max-w-4xl mx-auto py-16 px-8">
        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 bg-slate-900 rounded-xl flex items-center justify-center text-white shadow-lg">
            <FiInfo size={24} />
          </div>
          <h1 className="text-4xl font-black text-slate-900">Terms of Service</h1>
        </div>

        <div className="bg-white rounded-[2rem] p-10 shadow-xl shadow-slate-100/50 space-y-8 text-slate-600 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-4 flex items-center gap-2">
              <FiCheckCircle className="text-orange-500" /> 1. Enrollment & Admission
            </h2>
            <p>
              By submitting an enrollment request, you agree to provide accurate and truthful information. 
              Admission to specific courses (like O Level or ADCA) is subject to seat availability and 
              prerequisite verification.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-4 flex items-center gap-2">
              <FiAlertCircle className="text-orange-500" /> 2. Code of Conduct
            </h2>
            <p>
              Students are expected to maintain discipline within the lab premises. Unauthorized 
              distribution of institute study materials or software is strictly prohibited.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-4">3. Certification</h2>
            <p>
              Certificates are awarded only upon the successful completion of the course duration 
              and passing the internal or external (NIELIT) examinations as applicable.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-4">4. Limitation of Liability</h2>
            <p>
              Divya Computer Institute provides education and placement assistance but does not 
              guarantee immediate employment. We are not liable for any data loss on personal 
              devices brought into the lab.
            </p>
          </section>

          <div className="bg-orange-50 p-6 rounded-2xl border border-orange-100">
            <p className="text-sm font-bold text-orange-800">
              Governing Law: These terms are governed by the laws of Uttar Pradesh, India. 
              Any disputes shall be subject to the jurisdiction of the courts in Ghazipur.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}